module.exports = __webpack_public_path__ + "static/media/laptop.25617fe2.png";